<template>
  <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
          <v-card>
            <v-card-text>
              <div class="table-responsive" id="printMe">
                <div>
                  <div style=" text-align: center">
                    <h1 class="display-3 logoName">MSacco</h1>

                    <h5>P.O BOX 1919, 01000</h5>
                    <h5>Tel: 020678567 <span> Fax: 678457</span></h5>
                    <h5>Mobile: 078923778</h5>
                  </div><br>
                  <div class="row justify-content-between" style="margin-left: 3%">
                    <div class="col-6">

                      <h5>Statement Date: </h5>
                    </div>

                  </div><br>
                </div>
                <table class="table  mb-0 table-bordered" style="text-align: center">
                  <thead class="bg-light">
                  <tr>
                    <th scope="col" rowspan="2">Date</th>
                    <th scope="col" rowspan="2">Type</th>
                    <th scope="col" colspan="2">Amount</th>
                  </tr>
                  <tr>
                    <th scope="col">Debit</th>
                    <th scope="col">Credit</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>12/12/7897</td>
                    <td>Loan Repayment</td>
                    <td>30,000</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>12/12/7897</td>
                    <td>Interest Incurred</td>
                    <td></td>
                    <td>679</td>
                  </tr>
                  <tr>
                    <td>12/12/7897</td>
                    <td>Loan Repayment</td>
                    <td>20,000</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>12/12/7897</td>
                    <td>Initial Loan Amount</td>
                    <td></td>
                    <td>3,000,000</td>
                  </tr>
                  <tr>
                    <th colspan="2">Total</th>
                    <th>50,000</th>
                    <th>3,000,679</th>
                  </tr>
                  <tr>
                    <th colspan="2">Balance</th>
                    <th colspan="2">2,950,000</th>
                  </tr>
                  </tbody>
                </table>
              </div> <br>
              <button type="button" class="btn btn-primary" >PRINT</button>
            </v-card-text>
          </v-card>
   </base-header>
    </div>
</template>
<script>
  export default {
    name: 'LoanPayments',

    data() {
      return {

      }
    }
  }
</script>
<style>
</style>
